<div *ngFor="let item of filterDoc">
    <div>
        <ul class="grid-container documents-list">
            <li class="documents-list__item">
                <div class="grid-8 grid-tablet-6 grid-mobile-4">
                    <span class="documents-list__item-title">
                        {{ item.libelleNatureDocument }}
                    </span>
                    <span class="documents-list__item-info"> {{ 'documents.provided' | i18n }}&nbsp;{{ item.dateDepot | date: 'dd/MM/yyyy' }} </span>
                </div>
                <div class="grid-4 grid-tablet-6 centered-mobile">
                    <span class="documents-list__item-button">
                        <a (click)="downloadFile(item)" class="button button--primary" *ngIf="item.idGed" data-tag-commander="" [appTagCommander]="'tagCo.documents.document.' + item.typologie + '.download'">
                            <span>
                                <em class="icon icon--download-2"></em>
                                <span>
                                    {{ 'global.download' | i18n }}
                                </span>
                            </span>
                        </a>
                    </span>
                </div>
            </li>
        </ul>
    </div>
</div>
